import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    servings: Yup.number()
      .min(0.1, 'tracker.servings.validation.description')
      .max(30, 'tracker.servings.validation.description')
      .required('tracker.logMeal.input.validationError.empty'),
    notes: Yup.string().max(1500, 'mealDetails.editNote.limitReached'),
  });
};

export default validationSchema;
